import { render, staticRenderFns } from "./ConfirmCancellationPopup.vue?vue&type=template&id=2ec67884&scoped=true"
import script from "./ConfirmCancellationPopup.vue?vue&type=script&lang=ts"
export * from "./ConfirmCancellationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec67884",
  null
  
)

export default component.exports